/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvouchervaliduntil3Inputs */

const en_dropvouchervaliduntil3 = /** @type {(inputs: Dropvouchervaliduntil3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid until`)
};

const de_dropvouchervaliduntil3 = /** @type {(inputs: Dropvouchervaliduntil3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültig bis`)
};

/**
* | output |
* | --- |
* | "Valid until" |
*
* @param {Dropvouchervaliduntil3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvouchervaliduntil3 = /** @type {((inputs?: Dropvouchervaliduntil3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvouchervaliduntil3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvouchervaliduntil3(inputs)
	return de_dropvouchervaliduntil3(inputs)
});
export { dropvouchervaliduntil3 as "dropVoucherValidUntil" }